export const INTRO_COMPLETE_KEY = "ga_intro_complete";

export function hasSeenIntro() {
  try {
    return localStorage.getItem(INTRO_COMPLETE_KEY) === "true";
  } catch {
    return false;
  }
}

export function markIntroSeen() {
  try {
    localStorage.setItem(INTRO_COMPLETE_KEY, "true");
  } catch {
    // Private mode can block storage; the intro can show again next visit.
  }
}
